module.exports = __webpack_public_path__ + "static/media/physics_logo.e3938804.png";